export default "__VITE_ASSET__BUfnFvVj__"